

















import { computed, defineComponent, reactive } from '@vue/composition-api';

import stringLog from '@/table/stringLog';

import getStringLogs from '@/gql/getStringLogs.gql';

const Index = defineComponent({
  setup() {
    const search = reactive({
      text: '',
    });

    const logListVariables = computed(() => {
      const vars: { [key: string]: any } = {
        where: undefined,
      };
      if (search.text) {
        vars.where = {
          column: 'ACTION',
          operator: 'LIKE',
          value: `%${search.text}%`,
        };
      }
      return vars;
    });

    return {
      search,
      logListVariables,
      getStringLogs,
      getStringLogsResult: (data: any) => data.logs,
      stringLogOption: stringLog,
    };
  },
});

export default Index;
